export const BRANDS = {
  STAYCITY: "Staycity",
  WILDE: "Wilde",
};

export const determineBrandFromURL = () => {
  const domain = window.location.host.toString();
  if (domain.includes(BRANDS.WILDE.toLowerCase())) {
    return BRANDS.WILDE;
  }
  return BRANDS.STAYCITY;
};
